/**
 * Handles error responses from a fetch request.
 *
 * @param {Response} response - The response object from a fetch request.
 * @throws {Error} Throws an error if the response status is 500 or greater.
 * @returns {null} Returns null if no error is thrown.
 */
export default function handleErrorResponse(response) {
  if (response?.status >= 500) {
    throw new Error("Internal Server Error");
  }

  return null;
}
